import styled from 'styled-components'
import { CALENDAR_PAGE_CALENDAR_MESSAGE_WRAPPER_Z_INDEX } from 'z-indexes'

export const CalendarLoadingContainer = styled.div`
    flex: 1;
    width: 100%;
    background-color: ${props => props.theme.colorBgContainer};
    position: relative;
`
export const CalendarContainer = styled.div`
    width: 100%;
    display: contents;
    position: absolute;
    top: 0;
    left: 0;
`
export const MessageContainer = styled.div`
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: ${CALENDAR_PAGE_CALENDAR_MESSAGE_WRAPPER_Z_INDEX};
`
